module.exports = "/dist/assets/images/plus.svg";